import * as types from './mutation-types.js';

export const updateSelectedContainer = ({commit}, selectedContainer) => {
  commit(types.UPDATE_SELECTED_CONTAINER, selectedContainer)
}
